<button mat-raised-button color="primary">
  <ng-content></ng-content>
</button>